import { getAccountId, getRole } from '~/helpers'

const checkHasPermission = category => {
  if (category.permissionType) {
    return getRole() === category.permissionType
  }

  return true
}

const checkAccountPermission = category => {
  const shouldVerify = !!category?.accountRestriction

  if (!shouldVerify) return true

  const shouldShow = category?.accountsWithPermission?.includes(getAccountId())

  return shouldShow
}

const isSuperAdminAllowed = (category, isSuperAdmin) =>
  category.onlySuperAdmin ? isSuperAdmin : true

const checkRules = (
  category,
  options: { superAdmin: boolean } = { superAdmin: false }
) => {
  let isValidRole = true
  let isValidAccount = true
  const superAdmin = options?.superAdmin

  const shouldVerifyAccount = !!category?.accountRestriction
  const shouldVerifyRole = !!category?.permissionType

  if (shouldVerifyAccount) {
    isValidAccount = checkAccountPermission(category)
  }

  if (shouldVerifyRole) {
    isValidRole = getRole() === category.permissionType
  }

  return (
    isValidRole &&
    isValidAccount &&
    !category.hideMenu &&
    isSuperAdminAllowed(category, superAdmin)
  )
}

export {
  checkAccountPermission,
  checkHasPermission,
  checkRules,
  isSuperAdminAllowed
}
